<common-navigation></common-navigation>

<div class="default-box d-flex align-items-center mx-auto col-md-5 col-lg-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-xl-12 mb-100">
                <!-- Success Account Activation Message -->
                <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="success">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="success = !success">
                      <span aria-hidden="true">&times;</span>
                    </button>
                    New Activation link was successfully sent to your email.
                </div>

                <div class="alert alert-warning alert-dismissible fade show" role="alert"
                    *ngIf="error">
                    {{ errorMsg }}
                </div>
                <div id="page-redirection">
                    <a routerLink="/sign-in">
                        <img src="../../../../assets/images/arrow-left.png">
                        Back to sign in
                    </a>
                </div>
                <h3 class="display-4 box-title text-center">Please confirm your email</h3> <br>
                <p class="text-center mb-3">Please check your inbox for a confirmation email. Click the link in
                    the email to confirm your email address.</p>
                <p class="text-center mb-5">Didn't receive email? Please press below button to resend.<br>
                  <button type="submit" class="btn btn-primary px-5 btn-submit" (click)="resendEmail()">
                      Resend
                  </button>
                </p>
            </div>
        </div>
    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

</div>
